import { useEffect, useState } from 'react';
import { CatalogListData, CatalogueView } from '@zonofi/zono-money-store';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { WEBROUTES } from '@zonofi/zono-money-helpers';

export const useCatalogList = (
  products: CatalogListData[],
  catalogueView: CatalogueView,
  showPrice: boolean
) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const fromSource = searchParams.get('source');
  const hideAddToCart = searchParams.get('hideAddToCart');
  const orderId = searchParams.get('orderId');
  const [quantityMap, setQuantityMap] = useState<Record<number, any>>({});

  const openProductDetails = (productId: number, productVariantId: number) => {
    if (fromSource === 'order') {
      const searchParams = new URLSearchParams();
      if (hideAddToCart === 'true') {
        searchParams.set('hideAddToCart', 'true');
      }
      if (catalogueView === CatalogueView.ListView) {
        searchParams.set('hImg', 'true');
      }
      if (!showPrice) {
        searchParams.set('hp', 'true');
      }
      if (fromSource) {
        searchParams.set('source', fromSource);
      }
      if (orderId) {
        searchParams.set('orderId', orderId);
      }
      if (productVariantId) {
        searchParams.set('pvId', productVariantId?.toString());
      }
      navigate(
        `${WEBROUTES.PRODUCT_DETAILS}/${productId}?${searchParams.toString()}`
      );
    } else {
      const searchParams = new URLSearchParams();
      if (catalogueView === CatalogueView.ListView) {
        searchParams.set('hImg', 'true');
      }
      if (!showPrice) {
        searchParams.set('hp', 'true');
      }
      if (productVariantId) {
        searchParams.set('pvId', productVariantId?.toString());
      }
      navigate(
        `${WEBROUTES.PRODUCT_DETAILS}/${productId}?${searchParams.toString()}`
      );
    }
  };

  useEffect(() => {
    let quantityMapData: Record<number, any> = {};
    products?.forEach((item) => {
      if (item?.productVariantId) {
        quantityMapData[item?.productVariantId] = item?.addedQty;
      }
    });
    setQuantityMap({ ...quantityMapData });
  }, [products]);

  return { quantityMap, setQuantityMap, openProductDetails };
};
